import {Injectable} from "@angular/core";
import {IProductResolverData} from "./product-models";
import { Constants } from "../constants";


@Injectable({
    providedIn: 'root'
})
export class ProductRouteDataService {
    private productDataMap: Map<string, IProductResolverData> = new Map();

    setProductData(usanaId: string, productData: IProductResolverData): void {
        //Adding a timer to clear the product from the cache after 5 minutes.
        this.productDataMap.set(usanaId, {
            ...productData,
            cachedAt: Date.now()
        });
    }
    // This is only called from the RouteGuard so we can refresh the product data if it's older than 5 minutes.
    getProductDataWithTimerCheck(usanaId: string): IProductResolverData | undefined {
        const cached = this.productDataMap.get(usanaId);
        if (!cached || cached.cachedAt == null) {
            return undefined;
        }
        //If the product is older than 5 minutes, remove it from the cache.
        if (Date.now() - cached.cachedAt > Constants.PRODUCT_DATA_TTL_MS) {
            this.productDataMap.delete(usanaId);
            return undefined;
        }
        return cached;
    }
    // This is only called from the ProductComponent so we don't run into any timeout issues between the RouteGuard and the ProductComponent.
    getProductData(usanaId: string): IProductResolverData | undefined {
        return this.productDataMap.get(usanaId);
    }
    // Called from admin when product cache is cleared.
    clearProductData(): void {
        this.productDataMap.clear();
    }
}

